import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n'], ['\n  display: flex;\n  flex-direction: column;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: relative;\n  float: right;\n'], ['\n  position: relative;\n  float: right;\n']);

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon, UserPicture, Tooltip } from '../../..';
import { translations, utils } from 'gipsy-misc';
import Field from '../../components/Field';

var Requestor = function (_PureComponent) {
  _inherits(Requestor, _PureComponent);

  function Requestor() {
    _classCallCheck(this, Requestor);

    return _possibleConstructorReturn(this, (Requestor.__proto__ || Object.getPrototypeOf(Requestor)).apply(this, arguments));
  }

  _createClass(Requestor, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          isActive = _props.isActive,
          isOpen = _props.isOpen,
          value = _props.value;


      return value ? React.createElement(
        RequestorContainer,
        null,
        React.createElement(
          Field,
          {
            className: 'requestor-field' + (isActive ? ' active' : '') + (isOpen ? ' open' : ''),
            onClick: utils.DOM.stopPropagation },
          React.createElement(
            'div',
            { className: 'click-field row gp-layout gp-row gp-space-between gp-pointer' },
            React.createElement(
              'span',
              { className: 'field-label' },
              React.createElement(Icon, { icon: 'User', className: 'label-icon' }),
              React.createElement(
                'span',
                { className: 'label-text gp-pointer' },
                utils.string.capitalize(translations.general.requestor)
              )
            ),
            React.createElement(
              'span',
              { className: 'value' },
              React.createElement(
                StyledUserPicture,
                { border: '3px solid white', size: 36, src: value && value.picture, style: { right: 0 } },
                React.createElement(Tooltip, { text: utils.user.getDisplayName(value), vs: 42, hs: 18, position: 'top left' })
              )
            )
          )
        )
      ) : null;
    }
  }]);

  return Requestor;
}(PureComponent);

Requestor.propTypes = {
  id: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  value: PropTypes.object
};


export default Requestor;

var RequestorContainer = styled.div(_templateObject);

var StyledUserPicture = styled(UserPicture)(_templateObject2);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/Requestor/index.js
// module id = 500
// module chunks = 0